<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="师傅订单id,外键{zb_master_order.id}" prop="masterOrderId">
                <a-input v-model="queryParam.masterOrderId" allow-clear
                         placeholder="请输入师傅订单id,外键{zb_master_order.id}"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="金额" prop="rewardPrice">
                  <a-input v-model="queryParam.rewardPrice" allow-clear placeholder="请输入金额"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="说明" prop="describe">
                  <a-input v-model="queryParam.describe" allow-clear placeholder="请输入说明"/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
                    class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
                <a style="margin-left: 8px" @click="toggleAdvanced">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button v-hasPermi="['reward:reward:add']" type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus"/>
          新增
        </a-button>
        <a-button v-hasPermi="['reward:reward:edit']" :disabled="single" type="primary"
                  @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit"/>
          修改
        </a-button>
        <a-button v-hasPermi="['reward:reward:remove']" :disabled="multiple" type="danger" @click="handleDelete">
          <a-icon type="delete"/>
          删除
        </a-button>
        <a-button v-hasPermi="['reward:reward:export']" type="primary" @click="handleExport">
          <a-icon type="download"/>
          导出
        </a-button>
        <table-setting
          v-model="columns"
          :refresh-loading="loading"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          @refresh="getList"/>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :bordered="tableBordered"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :size="tableSize"
        rowKey="id"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider v-hasPermi="['reward:reward:edit']" type="vertical"/>
          <a v-hasPermi="['reward:reward:edit']" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>修改
          </a>
          <a-divider v-hasPermi="['reward:reward:remove']" type="vertical"/>
          <a v-hasPermi="['reward:reward:remove']" @click="handleDelete(record)">
            <a-icon type="delete"/>删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        :total="total"
        class="ant-table-pagination"
        show-quick-jumper
        show-size-changer
        @change="changeSize"
        @showSizeChange="onShowSizeChange"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageReward, listReward, delReward} from '@/api/reward/reward'
import CreateForm from './modules/CreateForm'
import {tableMixin} from '@/store/table-mixin'

export default {
  name: 'Reward',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        masterOrderId: null,
        rewardType: null,
        rewardPrice: null,
        describe: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '打赏id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '师傅订单id,外键{zb_master_order.id}',
          dataIndex: 'masterOrderId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '打赏类型,0-打赏,1-辅材',
          dataIndex: 'rewardType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '金额',
          dataIndex: 'rewardPrice',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '说明',
          dataIndex: 'describe',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: {customRender: 'createTime'},
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询打赏列表 */
    getList() {
      this.loading = true
      pageReward(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        masterOrderId: undefined,
        rewardType: undefined,
        rewardPrice: undefined,
        describe: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delReward(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('reward/reward/export', {
            ...that.queryParam
          }, `打赏_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
